import printerIcon from "../../resources/images/printer-icon.svg";
import eyeIcon from "../../resources/images/eye-icon.svg";
import officeChairIcon from "../../resources/images/office-chair-icon.svg";
import changeScoreIcon from "../../resources/images/change-score-ico.svg";
import downloadPositionReportIcon from "../../resources/images/download-position-report-ico.svg";
import sharePositionReportIcon from "../../resources/images/share-position-report.svg";
import commentFullscreenIcon from "../../resources/images/comment_fullscreen.svg";
import csvFileIcon from "../../resources/images/csv-file-icon.svg";
import pdfFileIcon from "../../resources/images/pdf-file-icon.svg";
import categoryIcon from "../../resources/images/category-icon.svg";
import idCardIcon from "../../resources/images/id-card-icon.svg";
import penToolIcon from "../../resources/images/pen-tool-icon.svg";
import accountIcon from "../../resources/images/account-icon.svg";
import mathPlusIcon from "../../resources/images/math-plus-icon.svg";
import emailAddressIcon from "../../resources/images/email-address-icon.svg";
import lockIcon from "../../resources/images/lock-icon.svg";
import mobilePhoneIcon from "../../resources/images/mobile-phone-icon.svg";
import questionMarkIcon from "../../resources/images/question-mark-icon.svg";
import crossIcon from "../../resources/images/cross-icon.svg";
import whatsappIcon from "../../resources/images/whatsapp-icon.svg";
import editBoxIcon from "../../resources/images/edit-box-icon.svg";
import deleteIcon from "../../resources/images/delete-icon.svg";
import accountSettingIcon from "../../resources/images/account-settings-icon.svg";
import groupIcon from "../../resources/images/group.svg";
import workingOnLaptop from "../../resources/images/working-on-laptop-icon.svg";
import businessIcon from "../../resources/images/business-team-icon.svg";
import brandingLogo from "../../resources/images/branding-logo.svg";
import uploadImageIcon from "../../resources/images/upload-image-icon.svg";
import homeIcon from "../../resources/images/home-icon.svg";
import audioIcon from "../../resources/images/audio-icon.svg";
import bookQuestionIcon from "../../resources/images/book-question-icon.svg";
import clipboardQuestionIcon from "../../resources/images/clipboard-question-icon.svg";
import codeSnipetIcon from "../../resources/images/code-snippet-icon.svg";
import playButtonRoundIcon from "../../resources/images/play-button-round-icon.svg";
import videoIcon from "../../resources/images/video-icon.svg";
import onlineSurveyIcon from "../../resources/images/left-nav-menu-icons/online-survey-icon.svg";
import searchIcon from "../../resources/images/left-nav-menu-icons/search-icon.svg";
import supportIcon from "../../resources/images/left-nav-menu-icons/support-icon.svg";
import textIcon from "../../resources/images/text-icon.svg";
import checkMarkicon from "../../resources/images/check-mark-icon.svg";
import closeLineIcon from "../../resources/images/close-line-icon.svg";
import languageTranslatorIcon from "../../resources/images/language-translator-icon.svg";
import moveArrowsIcon from "../../resources/images/move-arrows-icon.svg";
import copyIcon from "../../resources/images/copy-icon-3.svg";
import shareIcon from "../../resources/images/share-icon.svg";
import websiteHostingIcon from "../../resources/images/website-hosting-icon.svg";
import qrCodeIcon from "../../resources/images/qr-code-scan-icon.svg";
import collapseIcon from "../../resources/images/collapse-icon.svg";
import fileUploadIcon from "../../resources/images/file-upload-icon.svg";
import zoomInIcon from "../../resources/images/zoom-icon.svg";
import tabEmailIcon from "../../resources/images/tab-email-ico.svg";
import redirectIcon from "../../resources/images/redirect-ico.svg";
import settingsIcon from "../../resources/images/setting-icon.svg";
import zoomExpandIcon from "../../resources/images/zoom-expand.svg";
import filterIcon from "../../resources/images/filter-icon.svg";
import customSortIcon from "../../resources/images/custom-sort-icon.svg";
import tableFilterDropdownIcon from "../../resources/images/table-filter-dropdown-icon.svg";
import ampleHireLoaderBoundryCircle from "../../resources/images/ample-hire-loader-boundry-circle.svg";
import homeSchoolingIcon from "../../resources/images/home-schooling-icon.svg";
import calendarCheckMarkIcon from "../../resources/images/calendar-checkmark-icon.svg";
import ampleHireLogo from "../../resources/images/ample-logo.png";
import brandStrategicPartnerLogo from "../../resources/images/ample-logo.png";
import vectorImage from "../../resources/images/Vector.png";
import vectorImage2 from "../../resources/images/Vector-2.svg";
import vectorImage3 from "../../resources/images/Vector-3.svg";
import vectorImage4 from "../../resources/images/Vector-4.svg";
import vectorImage5 from "../../resources/images/Vector-5.svg";
import vectorImage6 from "../../resources/images/Vector-6.svg";
import vectorImage7 from "../../resources/images/Vector-7.svg";
import candImage from "../../resources/images/cand.png";
import dashboard from "../../resources/images/dashboard.png";
import interviewer from "../../resources/images/interviwer.png";
import notification from "../../resources/images/notificatin.png";
import profile from "../../resources/images/profile.png";
import infosysLogo from "../../resources/images/Infosys_logo.png";
import minusLogo from "../../resources/images/minus-icon.svg";
import plusIcon from "../../resources/images/plus-icon.svg";
import topNavLogo from "../../resources/images/ample-logo.png";
import undrawJoinSVG from "../../resources/images/undraw_join_re_w1lh.svg";
import undrawContentTeamSVG from "../../resources/images/undraw_content_team_re_6rlg.svg";
import failIconStatus from "../../resources/images/failed-icon.svg";
import greenFaceIcon from "../../resources/images/green-face-emoji.svg";
import yellowFaceIcon from "../../resources/images/yellow-face-emoji.svg";
import redFaceIcon from "../../resources/images/red-face-emoji.svg";
import billingAddressIcon from "../../resources/images/billing-address-icon.svg";
import moreOptionsVerticalIcon from "../../resources/images/more-vertical.svg";
import questionHideView from "../../resources/images/question-hideview.svg";
import commentblogIconsvg from "../../resources/images/comment-blog-icon.svg";
import previous from "../../resources/images/prv.svg";
import playIcoChattSvg from "../../resources/images/play-ico-chatt.svg";
import podcastLiveSvg from "../../resources/images/podcast-live-icon-chatt.svg";
import prevIcon from "../../resources/images/interview-rounds/image-table/prv.svg";
import nextIcon from "../../resources/images/interview-rounds/image-table/next.svg";
import micIcon from "../../resources/images/mic-microphone-icon-share.svg";
import thankYouSvg from "../../resources/images/interview-rounds/images/undraw_super_thank_you_re_f8bo-2.svg";

// left-nav-icons
import enterJobDetails from "../../resources/images/left-nav-menu-icons/enter-job-details.svg";
import defineInterview from "../../resources/images/left-nav-menu-icons/define-interview.svg";
import inviteCandidates from "../../resources/images/left-nav-menu-icons/invite-candidates.svg";
import checkInviteCandidates from "../../resources/images/left-nav-menu-icons/check-invited-candidates.svg";
import seeCompletedInterviews from "../../resources/images/left-nav-menu-icons/see-completed-interviews.svg";
import interviewReports from "../../resources/images/left-nav-menu-icons/interview-reports.svg";
import addOrEditUsers from "../../resources/images/left-nav-menu-icons/add-or-edit-users.svg";

// Images
import brandLogoImageWithTransparentBackground from "../../resources/images/ample-logo.png";
import brandLogoImageWithWhiteBackground from "../../resources/images/ample-logo.png";
import maleUserImageCircular from "../../resources/images/male-user-image-circular.png";
import entitySignupPageImage from "../../resources/images/entity-signup-page-image.svg";
import entitySignupSuccess from "../../resources/images/registration-success.svg";
import userSignupSigninPageImage from "../../resources/images/user-signup-signin-page-image.svg";
import cartoonDrinkingJuiceImage from "../../resources/images/cartoon-drinking-juice-image.svg";
import logoBg from "../../resources/images/logo-bg.svg";
import textEditOptions from "../../resources/images/text-edit-options.png";
import refreshIcon from "../../resources/images/refresh-icon.svg";
import logoutButtonIcon from "../../resources/images/logout-button-icon.svg";
import ampleHireVLogo from "../../resources/images/ample-logo.png";
import videoImage from "../../resources/images/video-image.png";
import Rect691Img from "../../resources/images/Rectangle-691.png";
import Rect722Img from "../../resources/images/Rectangle-722.png";
import WhatsAppImg from "../../resources/images/mobile-whatsapp.png";
import shareIconShareIcon from "../../resources/images/share-icon-share.svg";
import reportShareIcon from "../../resources/images/report-share.svg";
import pdfFilesIconShare from "../../resources/images/pdf-files-icon-share.svg";
import emailAddressIconShare from "../../resources/images/email-address-icon-share.svg";
import micMicrophoneIconShare from "../../resources/images/mic-microphone-icon-share.svg";
import questionMarkCircleOutlineIconShare from "../../resources/images/question-mark-circle-outline-icon-share.svg";
import phoneIconShare from "../../resources/images/phone-icon-share.svg";
import textDocumentCheckIconShare from "../../resources/images/text-document-check-icon-share.svg";
import whatsappIconShare from "../../resources/images/whatsapp-icon-share.svg";
import filterSettingIconShare from "../../resources/images/filter-setting-icon-share.svg";
import reportLogo from "../../resources/images/ample-logo.png";
import reportLogo2 from "../../resources/images/report-2.png";
import enhanceTextIcon from "../../resources/images/enhance-text.svg";
import enhanceAudioIcon from "../../resources/images/enhance-audio.svg";
import filterSettingIconWhite from "../../resources/images/filter-setting-icon-white.svg";

// invited candidates icons
import checkBackground from "../../resources/images/invited-candidate/check-background.svg";
import checklight from "../../resources/images/invited-candidate/checklight.svg";
import completeIcon from "../../resources/images/invited-candidate/complete-icon.svg";
import crossIconInvitedCandidate from "../../resources/images/invited-candidate/cross-icon.svg";
import crossIconInvitedCandidateDark from "../../resources/images/invited-candidate/cross-icon-dark.svg";
import doubleArrowRightIcon from "../../resources/images/invited-candidate/double-arrow-right-icon.svg";
import emailInvitationInviteIcon from "../../resources/images/invited-candidate/email-invitation-invite-icon.svg";
import expandIcon3 from "../../resources/images/invited-candidate/expand-icon-3.svg";
import exportShareIcon from "../../resources/images/invited-candidate/export-share-icon.svg";
import exportShareIconDark from "../../resources/images/invited-candidate/export-share-icon-dark.svg";
import failedIcon from "../../resources/images/invited-candidate/failed-icon.svg";
import githubIcon from "../../resources/images/invited-candidate/github-icon.svg";
import instructionIcon from "../../resources/images/invited-candidate/instruction-icon.svg";
import internetspeed from "../../resources/images/invited-candidate/internetspeed.svg";
import languageTranslatorIconInvitedCandidate from "../../resources/images/invited-candidate/language-translator-icon.svg";
import linkIcon from "../../resources/images/invited-candidate/link-icon.svg";
import linkIconDark from "../../resources/images/invited-candidate/link-icon-dark.svg";
import linkedinIcon from "../../resources/images/invited-candidate/linkedin-icon.svg";
import logoStackoverflow from "../../resources/images/invited-candidate/logo-stackoverflow.svg";
import musicSwitchOnOffButtonIcon from "../../resources/images/invited-candidate/music-switch-on-off-button-icon.svg";
import next from "../../resources/images/invited-candidate/next.svg";
import pendingIcon from "../../resources/images/invited-candidate/pending-icon.svg";
import phoneIcon from "../../resources/images/invited-candidate/phone-icon.svg";
import phoneIconDark from "../../resources/images/invited-candidate/phone-icon-dark.svg";
import prv from "../../resources/images/invited-candidate/prv.svg";
import replyArrowIcon from "../../resources/images/invited-candidate/reply-arrow-icon.svg";
import replyArrowIconDark from "../../resources/images/invited-candidate/reply-arrow-icon-dark.svg";
import sandClockFullLineIcon from "../../resources/images/invited-candidate/sand-clock-full-line-icon.svg";
import soundCheck from "../../resources/images/invited-candidate/sound-check.svg";
import soundIcon3 from "../../resources/images/invited-candidate/sound-icon-3.svg";
import timePeriodIcon from "../../resources/images/invited-candidate/time-period-icon.svg";
import timePeriodIconDark from "../../resources/images/invited-candidate/time-period-icon-dark.svg";
import userClipboardIcon from "../../resources/images/invited-candidate/user-clipboard-icon.svg";
import verticalDotsIcon3 from "../../resources/images/invited-candidate/vertical-dots-icon-3.svg";
import accessDeniedForbiddenIcon from "../../resources/images/invited-candidate/access-denied-forbidden-icon.svg";
import whatsappIconInvitedCandidate from "../../resources/images/invited-candidate/whatsapp-icon.svg";
import userProfileImage from "../../resources/images/user-profile-image.jpg";
import addMaleUserIcon from "../../resources/images/add-male-user-icon.svg";
import giftHandPresentIcon from "../../resources/images/gift-hand-present-icon.svg";
import clockIcon from "../../resources/images/clock-icon.svg";
import rejectedIcon from "../../resources/images/rejected-icon.svg";
// Audio assets
import demoAudio from "../../resources/audios/demo-audio.mp3";

import publicCopyIcon from "../../resources/images/copy-icon 3.svg";
import publicShareIcon from "../../resources/images/share-icon 1.svg";
import publicHostingIcon from "../../resources/images/website-hosting-icon 1.svg";
import publicEditIcon from "../../resources/images/edit-box-icon (2) 2.svg";
import publicQRCodeIcon from "../../resources/images/qr-code-scan-icon 1.svg";
import linkSvgIcon from "../../resources/images/image-table/link-icon.svg";
import timePeriodSvgIcon from "../../resources/images/image-table/time-period-icon.svg";
import crossSvgIcon from "../../resources/images/image-table/cross-icon.svg";
import replyArrowSvgIcon from "../../resources/images/image-table/reply-arrow-icon.svg";
import shareSvgIcon from "../../resources/images/image-table/export-share-icon.svg";
import doubleArrowRightSvgIcon from "../../resources/images/image-table/double-arrow-right-icon.svg";

import scoresByInterviewRound from "../../resources/images/image-table/Scores-by-Interview-Round.svg";
import candidateVideoAnswer from "../../resources/images/image-table/Candidate-Video-Answers.svg";
import candidateScoresSummary from "../../resources/images/image-table/Candidate-Scores-Summary.svg";
import summaryByPosition from "../../resources/images/image-table/Summary-by-Position.svg";

import playIconCircle from "../../resources/images/play-icon-circle.svg";
import playIconRoundedRectangle from "../../resources/images/play-icon-rounded-rectangle.svg";
import pauseIconCircle from "../../resources/images/pause-icon-circle.svg";

import excelIcon from "../../resources/images/xls-file-icon-fileupload.svg";
import excelIconWhite from "../../resources/images/xls-file-icon-fileupload-white.svg";

const image = {
  brandStrategicPartnerLogo: brandStrategicPartnerLogo || "brandStrategicPartnerLogo",
  brandLogoImageWithTransparentBackground: brandLogoImageWithTransparentBackground,
  brandLogoImageWithWhiteBackground:
    brandLogoImageWithWhiteBackground || "brandLogoImageWithWhiteBackground",
  maleUserImageCircular: maleUserImageCircular || "maleUserImageCircular",
  userProfileImage: userProfileImage || "userProfileImage",
  entitySignupPageImage: entitySignupPageImage || "entitySignupPageImage",
  entitySignupSuccess: entitySignupSuccess || "entitySignupSuccess",
  userSignupSigninPageImage:
    userSignupSigninPageImage || "userSignupSigninPageImage",
  cartoonDrinkingJuiceImage:
    cartoonDrinkingJuiceImage || "cartoonDrinkingJuiceImage",
  logoBg: logoBg || "logoBg",
  textEditOptions: textEditOptions || "textEditOptions",
  dashboard: dashboard || "dashboard",
  notification: notification || "notification",
  interviewer: interviewer || "interviewer",
  profile: profile || "profile",
  candImage: candImage || "candImage",
  vectorImage: vectorImage || "vectorImage",
  infosysLogo: infosysLogo || "infosysLogo",
  ampleHireVLogo: ampleHireVLogo || "ampleHireVLogo",
  undrawContentTeamSVG: undrawContentTeamSVG || "undrawContentTeamSVG",
  videoImage: videoImage || "videoImage",
  Rect691Img: Rect691Img || "Rect691Img",
  Rect722Img: Rect722Img || "Rect722Img",
  WhatsAppImage: WhatsAppImg || "WhatsAppImg",
};

const icon = {
  refreshIcon: refreshIcon || "refreshIcon",
  printerIcon: printerIcon || "printerIcon",
  eyeIcon: eyeIcon || "eyeIcon",
  officeChairIcon: officeChairIcon || "officeChairIcon",
  csvFileIcon: csvFileIcon || "csvFileIcon",
  pdfFileIcon: pdfFileIcon || "pdfFileIcon",
  categoryIcon: categoryIcon || "categoryIcon",
  idCardIcon: idCardIcon || "idCardIcon",
  penToolIcon: penToolIcon || "penToolIcon",
  accountIcon: accountIcon || "accountIcon",
  mathPlusIcon: mathPlusIcon || "mathPlusIcon",
  emailAddressIcon: emailAddressIcon || "emailAddressIcon",
  lockIcon: lockIcon || "lockIcon",
  mobilePhoneIcon: mobilePhoneIcon || "mobilePhoneIcon",
  questionMarkIcon: questionMarkIcon || "questionMarkIcon",
  crossIcon: crossIcon || "crossIcon",
  whatsappIcon: whatsappIcon || "whatsappIcon",
  editBoxIcon: editBoxIcon || "editBoxIcon",
  enterJobDetails: enterJobDetails || "enterJobDetails",
  defineInterview: defineInterview || "defineInterview",
  onlineSurveyIcon: onlineSurveyIcon || "onlineSurveyIcon",
  inviteCandidates: inviteCandidates || "inviteCandidates",
  checkInviteCandidates: checkInviteCandidates || "checkInviteCandidates",
  seeCompletedInterviews: seeCompletedInterviews || "seeCompletedInterviews",
  interviewReports: interviewReports || "interviewReports",
  addOrEditUsers: addOrEditUsers || "addOrEditUsers",
  searchIcon: searchIcon || "searchIcons",
  supportIcon: supportIcon || "supportIcon",
  deleteIcon: deleteIcon || "deleteIcon",
  accountSettingIcon: accountSettingIcon || "accountSettingIcon",
  groupIcon: groupIcon || "groupIcon",
  workingOnLaptop: workingOnLaptop || "workingOnLaptop",
  businessIcon: businessIcon || "businessIcon",
  brandingLogo: brandingLogo || "brandingLogo",
  uploadImageIcon: uploadImageIcon || "uploadImageIcon",
  homeIcon: homeIcon || "homeIcon",
  audioIcon: audioIcon || "audioIcon",
  bookQuestionIcon: bookQuestionIcon || "bookQuestionIcon",
  clipboardQuestionIcon: clipboardQuestionIcon || "clipboardQuestionIcon",
  codeSnipetIcon: codeSnipetIcon || "codeSnipetIcon",
  playButtonRoundIcon: playButtonRoundIcon || "playButtonRoundIcon",
  videoIcon: videoIcon || "videoIcon",
  textIcon: textIcon || "textIcon",
  checkMarkicon: checkMarkicon || "checkMarkicon",
  closeLineIcon: closeLineIcon || "closeLineIcon",
  languageTranslatorIcon: languageTranslatorIcon || "languageTranslatorIcon",
  moveArrowsIcon: moveArrowsIcon || "moveArrowsIcon",
  copyIcon: copyIcon || "copyIcon",
  shareIcon: shareIcon || "shareIcon",
  qrCodeIcon: qrCodeIcon || "qrCodeIcon",
  websiteHostingIcon: websiteHostingIcon || "websiteHostingIcon",
  collapseIcon: collapseIcon || "collapseIcon",
  fileUploadIcon: fileUploadIcon || "fileUploadIcon",
  zoomInIcon: zoomInIcon || "zoomInIcon",
  tabEmailIcon: tabEmailIcon || "tabEmailIcon",
  redirectIcon: redirectIcon || "redirectIcon",
  settingsIcon: settingsIcon || "settingsIcon",
  zoomExpandIcon: zoomExpandIcon || "zoomExpandIcon",
  filterIcon: filterIcon || "filterIcon",
  customSortIcon: customSortIcon || "customSortIcon",
  tableFilterDropdownIcon: tableFilterDropdownIcon || "tableFilterDropdownIcon",
  ampleHireLoaderBoundryCircle:
    ampleHireLoaderBoundryCircle || "ampleHireLoaderBoundryCircle",
  ampleHireLogo: ampleHireLogo || "ampleHireLogo",
  prevIcon: prevIcon || "prevIcon",
  nextIcon: nextIcon || "nextIcon",
  // invited candidate
  checkBackground: checkBackground || "checkBackground",
  checklight: checklight || "checklight",
  completeIcon: completeIcon || "completeIcon",
  crossIconInvitedCandidate:
    crossIconInvitedCandidate || "crossIconInvitedCandidate",
  crossIconInvitedCandidateDark:
    crossIconInvitedCandidateDark || "crossIconInvitedCandidateDark",
  doubleArrowRightIcon: doubleArrowRightIcon || "doubleArrowRightIcon",
  emailInvitationInviteIcon:
    emailInvitationInviteIcon || "emailInvitationInviteIcon",
  expandIcon3: expandIcon3 || "expandIcon3",
  exportShareIcon: exportShareIcon || "exportShareIcon",
  exportShareIconDark: exportShareIconDark || "exportShareIconDark",
  failedIcon: failedIcon || "failedIcon",
  githubIcon: githubIcon || "githubIcon",
  instructionIcon: instructionIcon || "instructionIcon",
  internetspeed: internetspeed || "internetspeed",
  languageTranslatorIconInvitedCandidate:
    languageTranslatorIconInvitedCandidate ||
    "languageTranslatorIconInvitedCandidate",
  linkIcon: linkIcon || "linkIcon",
  linkIconDark: linkIconDark || "linkIconDark",
  linkedinIcon: linkedinIcon || "linkedinIcon",
  logoStackoverflow: logoStackoverflow || "logoStackoverflow",
  musicSwitchOnOffButtonIcon:
    musicSwitchOnOffButtonIcon || "musicSwitchOnOffButtonIcon",
  next: next || "next",
  pendingIcon: pendingIcon || "pendingIcon",
  phoneIcon: phoneIcon || "phoneIcon",
  phoneIconDark: phoneIconDark || "phoneIconDark",
  prv: prv || "prv",
  replyArrowIcon: replyArrowIcon || "replyArrowIcon",
  replyArrowIconDark: replyArrowIconDark || "replyArrowIconDark",
  sandClockFullLineIcon: sandClockFullLineIcon || "sandClockFullLineIcon",
  soundCheck: soundCheck || "soundCheck",
  soundIcon3: soundIcon3 || "soundIcon3",
  timePeriodIcon: timePeriodIcon || "timePeriodIcon",
  timePeriodIconDark: timePeriodIconDark || "timePeriodIconDark",
  userClipboardIcon: userClipboardIcon || "userClipboardIcon",
  verticalDotsIcon3: verticalDotsIcon3 || "verticalDotsIcon3",
  accessDeniedForbiddenIcon:
    accessDeniedForbiddenIcon || "accessDeniedForbiddenIcon",
  whatsappIconInvitedCandidate:
    whatsappIconInvitedCandidate || "whatsappIconInvitedCandidate",
  homeSchoolingIcon: homeSchoolingIcon || "homeSchoolingIcon",
  calendarCheckMarkIcon: calendarCheckMarkIcon || "calendarCheckMarkIcon",
  minusLogo: minusLogo || "minusLogo",
  topNavLogo: topNavLogo || "topNavLogo",
  undrawJoinSVG: undrawJoinSVG || "undrawJoinSVG",
  failIconStatus: failIconStatus || "failIconStatus",
  plusIcon: plusIcon || "plusIcon",
  greenFaceIcon: greenFaceIcon || "greenFaceIcon",
  yellowFaceIcon: yellowFaceIcon || "yellowFaceIcon",
  redFaceIcon: redFaceIcon || "redFaceIcon",
  logoutButtonIcon: logoutButtonIcon || "logoutButtonIcon",
  billingAddressIcon: billingAddressIcon || "billingAddressIcon",
  moreOptionsVerticalIcon: moreOptionsVerticalIcon || "moreOptionsVerticalIcon",
  questionHideView: questionHideView || "questionHideView",
  commentblogIconsvg: commentblogIconsvg || "commentblogIcon",
  previous: previous || "previous",
  playIcoChattSvg: playIcoChattSvg || "playIcoChattSvg",
  podcastLiveSvg: podcastLiveSvg || "podcastLiveSvg",
  previous: previous || "previous",
  changeScoreIcon: changeScoreIcon || "changeScoreIcon",
  commentFullscreenIcon: commentFullscreenIcon || "commentFullscreenIcon",
  downloadPositionReportIcon:
    downloadPositionReportIcon || "downloadPositionReportIcon",
  sharePositionReportIcon: sharePositionReportIcon || "sharePositionReportIcon",
  publicCopyIcon: publicCopyIcon || "publicCopyIcon",
  publicShareIcon: publicShareIcon || "publicShareIcon",
  publicHostingIcon: publicHostingIcon || "publicHostingIcon",
  publicEditIcon: publicEditIcon || "publicEditIcon",
  publicQRCodeIcon: publicQRCodeIcon || "publicQRCodeIcon",
  linkSvgIcon: linkSvgIcon || "linkSvgIcon",
  timePeriodSvgIcon: timePeriodSvgIcon || "timePeriodSvgIcon",
  crossSvgIcon: crossSvgIcon || "crossSvgIcon",
  replyArrowSvgIcon: replyArrowSvgIcon || "replyArrowSvgIcon",
  shareSvgIcon: shareSvgIcon || "shareSvgIcon",
  doubleArrowRightSvgIcon: doubleArrowRightSvgIcon || "doubleArrowRightSvgIcon",
  scoresByInterviewRound: scoresByInterviewRound || "scoresByInterviewRound",
  candidateVideoAnswer: candidateVideoAnswer || "candidateVideoAnswer",
  candidateScoresSummary: candidateScoresSummary || "candidateScoresSummary",
  summaryByPosition: summaryByPosition || "summaryByPosition",
  shareIconShareIcon: shareIconShareIcon || "shareIconShareIcon",
  reportShareIcon: reportShareIcon || "reportShareIcon",
  pdfFilesIconShare: pdfFilesIconShare || "pdfFilesIconShare",
  emailAddressIconShare: emailAddressIconShare || "emailAddressIconShare",
  micMicrophoneIconShare: micMicrophoneIconShare || "micMicrophoneIconShare",
  questionMarkCircleOutlineIconShare:
    questionMarkCircleOutlineIconShare || "questionMarkCircleOutlineIconShare",
  phoneIconShare: phoneIconShare || "phoneIconShare",
  textDocumentCheckIconShare:
    textDocumentCheckIconShare || "textDocumentCheckIconShare",
  whatsappIconShare: whatsappIconShare || "whatsappIconShare",
  filterSettingIconShare: filterSettingIconShare || "filterSettingIconShare",
  filterSettingIconWhite: filterSettingIconWhite || "filterSettingIconWhite",
  micIcon: micIcon || "micIcon",
  thankYouSvg: thankYouSvg || "thankYouSvg",
  reportLogo: reportLogo || "reportLogo",
  reportLogo2: reportLogo2 || "reportLogo2",
  vectorImage2: vectorImage2 || "vectorImage2",
  vectorImage3: vectorImage3 || "vectorImage3",
  vectorImage4: vectorImage4 || "vectorImage4",
  vectorImage5: vectorImage5 || "vectorImage5",
  vectorImage6: vectorImage6 || "vectorImage6",
  vectorImage7: vectorImage7 || "vectorImage7",
  enhanceTextIcon: enhanceTextIcon || "enhanceTextIcon",
  enhanceAudioIcon: enhanceAudioIcon || "enhanceAudioIcon",
  playIconCircle: playIconCircle || "playIconCircle",
  playIconRoundedRectangle:
    playIconRoundedRectangle || "playIconRoundedRectangle",
  pauseIconCircle: pauseIconCircle || "pauseIconCircle",
  excelIcon: excelIcon || "excelIcon",
  excelIconWhite: excelIconWhite || "excelIconWhite",
};

const audio = {
  demoAudio: demoAudio || "demoAudio",
};

export { icon, image, audio };
